import React, { useRef, useState } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { Menu } from 'react-bootstrap/lib/Dropdown';
import DropdownToggle from 'react-bootstrap/lib/DropdownToggle';
import LocalizationStore from "LocalizationStore";


const HoverMenu = ({ title, items, isDisabled, onSelect }) => {
  const [open, setOpen] = useState(false);
  const tabRef = useRef(null);
  const menuRef = useRef(null);

  const handleMouseEnter = () => setOpen(true);

  const handleMouseLeave = () => {
    const isHoveringTab = tabRef.current?.matches(':hover');
    const isHoveringMenu = menuRef.current?.matches(':hover');
    if (!isHoveringTab && !isHoveringMenu) {
      setOpen(false);
    }
  };

  return (
    <div
      className="tab-button-wrapper"
      ref={tabRef}
      onMouseEnter={() => !isDisabled && handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
    >
      <Dropdown
        id={`dropdown-${title?.replace(' ', '')}`}
        open={open}
        onToggle={() => { }}
        dropup
        bsStyle="default"
        className="tab-dropdown-wrapper"
      >
        <span className={`blue-txt ${isDisabled ? 'disabled' : ''}`} onClick={(event)=> event.preventDefault()}>
          {title}</span>
        <Menu
        >
          <div ref={menuRef}
          >
            {items?.map((item) => (
              <MenuItem
                key={item.id}
                eventKey={item.id}
                onClick={() => {
                    onSelect(item);
                    setOpen(false);
                }}
              >
                <span>{item.label}</span>
              </MenuItem>
            ))}
          </div>
        </Menu>
      </Dropdown>
    </div>
  );
};

export default HoverMenu;
